<template>
  <div class="content">
    <Header :hasBack="goback" :hasRight="false">
    </Header>
    <div class="setting">
      <div style="width: 600px; flex: 1; margin: 0 auto; padding-top: 40px">
        <div class="setting-title">Setting</div>
        <el-form ref="form" :moel="form" label-width="150px">
          <el-form-item label="Concurrency num: ">
            <el-input v-model="form.threadnum"></el-input>
          </el-form-item>
          <el-form-item label="Max select file num: ">
            <el-input v-model="form.maxSelectMultipleFileNum"></el-input>
          </el-form-item>
          <el-form-item v-if="getOSName() == 'Windows'" label="Select file with web: " label-position="left">
            <el-switch
              v-model="form.selectFileWithWeb"
              active-color="#13ce66"
              inactive-color="#ff4949"
              class="switch-kssd">
            </el-switch>
          </el-form-item>
          <el-form-item label="User ID: ">
            <el-input :value="userID" disabled></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="onSubmit">Submit</el-button>
            <el-button @click="goHome">Return home</el-button>
          </el-form-item>
        </el-form>
      </div>
      <Footer />
    </div>
  </div>
</template>

<script>
import Header from './common/header.vue'
import Footer from './common/footer.vue'

import { getOSName } from '../utils/common'

export default {
  name: 'setting',
  data () {
    return {
      goback: true,
      userID: '',
      form: {
        threadnum: 3,
        maxSelectMultipleFileNum: 100,
        settimeoutTime: 2000,
        selectFileWithWeb: false
      }
    }
  },
  components: { Footer, Header },
  mounted () {
    this.goback = this.$route.query.goback || true
    let commonSetting = localStorage.getItem('commonSetting')
    if (commonSetting) {
      this.form = JSON.parse(commonSetting)
      console.log('form:', this.form)
    }
    this.userID = localStorage.getItem('userID')
  },
  methods: {
    getOSName,
    onSubmit () {
      localStorage.setItem('commonSetting', JSON.stringify(this.form))
      this.$message({
        message: 'update success.',
        type: 'success'
      })
    },
    goHome () {
      this.$router.push('/')
    }
  }
}
</script>

<style scoped>
.content {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
}
.setting {
  flex: 1;
  display: flex;
  height: 100%;
  flex-direction: column;
  width: 1170px;
  margin: auto;
}
.setting-title {
  font-size: 24px;
  text-align: left;
  padding-bottom: 10px;
  border-bottom: 1px solid #eee;
  margin-bottom: 20px;
}

.switch-kssd {
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/setting.vue